/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-34428f12.mjs';

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}
var isUndefined_1 = isUndefined;

export { isUndefined_1 as i };
//# sourceMappingURL=dep-9a7888c7.mjs.map
